import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import { reactive, computed, onMounted, ref } from 'vue'
import { partnerGet, partnerDelete, partnerDetail } from '@/api/marketing/marketingManage'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import CustomerArea from '@/components/CustomerArea'
import { useRouter } from 'vue-router'
import { listByParamCodes } from '@/api/common'
import Modal from '@/hooks/modalType'
import partnerFollowRecordFrom from './components/partnerFollowRecordFrom.vue'
import partnerActivityFrom from './components/partnerActivityFrom.vue'
import { DcMessage } from '@dc-platform/dc-components'
import type { PartnerManageList } from '@/typings/api/marketingManage'

const __default__ = { name: 'DcCosLbuPartnerManage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const tableRef = ref()
const partnerFollowFromRef = ref()
const partnerActivityFromRef = ref()
const queryForm = reactive({})
const paramCodeData = reactive<{
  zbu_grade_lbu: []
  zbu_partner_nature_lbu: []
  zbu_main_customers_lbu: []
  zbu_campaign_type_lbu: []
  zbu_partner_role_lbu: []
  zbu_partner_area_lbu: []
}>({
  zbu_grade_lbu: [], // 评级
  zbu_partner_nature_lbu: [], // 合作伙伴性质
  zbu_main_customers_lbu: [], // 主要客群
  zbu_campaign_type_lbu: [], // 市场活动类型
  zbu_partner_role_lbu: [],
  zbu_partner_area_lbu: []
})
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: [
      'zbu_grade_lbu',
      'zbu_partner_nature_lbu',
      'zbu_main_customers_lbu',
      'zbu_campaign_type_lbu',
      'zbu_partner_role_lbu',
      'zbu_partner_area_lbu'
    ]
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const handleDelete = (row: PartnerManageList) => {
  Modal.delete({
    name: row.name,
    onOk() {
      partnerDelete({
        id: row.id
      }).then((res) => {
        DcMessage.success('删除成功')
        tableRef.value.delFetch()
      })
    }
  })
}
const getList = (params: object, callBack: (res: any) => void) => {
  partnerGet({
    ...params,
    ...queryForm
  }).then((res) => {
    callBack(res)
  })
}
// 新增编辑函数
const handleAdd = () => {
  router.push({
    path: '/lbu/partnerManage/add'
  })
}
// 获取掩码信息
const showMask = (record: PartnerManageList, callBack: (res: any) => void) => {
  partnerDetail({
    id: record.id,
    isForUpdate: true
  }).then((res) => {
    if (res.data?.partnerContact) {
      callBack({
        ...res.data.partnerContact,
        contactName: res.data.partnerContact.name
      })
    } else {
      callBack({})
    }
  })
}
const handleEdit = (row: PartnerManageList) => {
  router.push({
    path: '/lbu/partnerManage/edit',
    query: {
      id: row.id
    }
  })
}
// 维护关系
const handleFollow = (row: PartnerManageList) => {
  partnerFollowFromRef.value.toggle({
    partnerName: row.name,
    partnerId: row.id
  })
}
// 添加活动
const handleActivity = (row: PartnerManageList) => {
  partnerActivityFromRef.value.toggle({
    partnerName: row.name,
    partnerId: row.id
  })
}
const success = () => {
  tableRef.value.fetch()
}
const columns = computed(() => [
  {
    title: '合作伙伴名称',
    dataIndex: 'name',
    cosType: 'link',
    path: '/lbu/partnerManage/view',
    query: ['id', 'name'],
    fixed: 'left',
    width: 200
  },
  {
    title: '合作伙伴简介',
    dataIndex: 'intro'
  },
  {
    title: '评级',
    dataIndex: 'starGrade',
    dicData: dataConfig.starGrade,
    filterNoVal: true
  },
  {
    title: '知名度',
    dataIndex: 'popularityDegree',
    filterNoVal: true
  },
  {
    title: '契合度',
    dataIndex: 'agreementDegree',
    filterNoVal: true
  },
  {
    title: '关系',
    dataIndex: 'relationDegree',
    filterNoVal: true
  },
  {
    title: 'Base地',
    dataIndex: 'areaId'
  },
  {
    title: '合作伙伴区域',
    dataIndex: 'regionId',
    dicData: paramCodeData.zbu_partner_area_lbu,
    filterNoVal: true
  },
  {
    title: '性质',
    dataIndex: 'property',
    dicData: paramCodeData.zbu_partner_nature_lbu,
    filterNoVal: true
  },
  {
    title: '主要客群',
    dataIndex: 'mainCustomers',
    dicData: paramCodeData.zbu_main_customers_lbu
  },
  {
    title: '市场活动类型',
    dataIndex: 'activityTypes',
    dicData: paramCodeData.zbu_campaign_type_lbu
  },
  {
    title: '网站/公众号',
    dataIndex: 'webSite'
  },
  {
    title: '联系人',
    dataIndex: 'contactName',
    cosType: 'mask'
  },
  {
    title: '性别',
    dataIndex: 'sex',
    dicData: dataConfig.genderEnum,
    filterNoVal: true
  },
  {
    title: '角色',
    dataIndex: 'role',
    dicData: paramCodeData.zbu_partner_role_lbu,
    filterNoVal: true
  },
  {
    title: '手机',
    dataIndex: 'mobile',
    cosType: 'mask'
  },
  {
    title: '邮箱',
    dataIndex: 'email',
    cosType: 'mask'
  },
  {
    title: '微信号',
    dataIndex: 'wechat',
    cosType: 'mask'
  },
  {
    title: 'QQ号',
    dataIndex: 'qq',
    cosType: 'mask'
  },
  {
    title: '最新维护时间',
    dataIndex: 'recordCreateTime',
    width: 190
  },
  {
    title: '具体内容',
    dataIndex: 'content'
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: 240,
    fixed: 'right'
  }
])

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onMask: showMask,
            onFetch: getList,
            search: queryForm,
            "onUpdate:search": _cache[7] || (_cache[7] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosLbuPartnerManage"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "name",
                    label: "合作伙伴名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.name,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.name) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "starGrade",
                    label: "评级"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.starGrade,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.starGrade) = $event)),
                        allowClear: "",
                        placeholder: "请选择",
                        options: _unref(dataConfig).starGrade
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "contactName",
                    label: "联系人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.contactName,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.contactName) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "property",
                    label: "性质"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ParamCodesSelect, {
                        options: paramCodeData.zbu_partner_nature_lbu,
                        value: queryForm.property,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.property) = $event))
                      }, null, 8, ["options", "value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "mainCustomer",
                    label: "主要客群"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ParamCodesSelect, {
                        options: paramCodeData.zbu_main_customers_lbu,
                        value: queryForm.mainCustomer,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.mainCustomer) = $event))
                      }, null, 8, ["options", "value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "activityType",
                    label: "市场活动类型"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ParamCodesSelect, {
                        options: paramCodeData.zbu_campaign_type_lbu,
                        value: queryForm.activityType,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.activityType) = $event))
                      }, null, 8, ["options", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'areaId')
                ? (_openBlock(), _createBlock(_unref(CustomerArea), {
                    key: 0,
                    type: "text",
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 1 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleFollow(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("维护关系")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_partner_maintain_add_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleActivity(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("新增活动")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_partner_activity_add_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_partner_edit_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleDelete(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_partner_del_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (handleAdd()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_partner_add_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_zbu",
                taskType: "103",
                search: queryForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'lbu_partner_export_btn']
              ])
            ]),
            _: 1
          }, 8, ["columns", "search"]),
          _createVNode(partnerFollowRecordFrom, {
            ref_key: "partnerFollowFromRef",
            ref: partnerFollowFromRef,
            onSuccess: success
          }, null, 512),
          _createVNode(partnerActivityFrom, {
            ref_key: "partnerActivityFromRef",
            ref: partnerActivityFromRef
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})